var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:this.themeColours,staticStyle:{"opacity":"0"},attrs:{"id":"app"}},[_c('div',{attrs:{"id":"ze-snippet-wrapper"}}),_c('router-view',{staticClass:"flex-grow-1",class:_vm.interfaceLoading ? 'switching-interface' : ''})],1)}
var staticRenderFns = []

export { render, staticRenderFns }